import { createSlice, isFulfilled, isPending, isRejected } from "@reduxjs/toolkit"
import { create_province_rule, get_province_rules, update_province_rule } from "../actions/rulesAction"
import { toast } from "react-toastify"

const initial_state ={
    isLoading:false,
    isSuccess:false,
    isError:false,
    rules:[],
    province_rule:{}
}

const create_rules_slice= createSlice({
    name:'province_rules',
    initialState:initial_state,
    reducers:{},
    extraReducers:(builder)=>{
        builder
        .addCase(create_province_rule.fulfilled,state=>{
            toast("Province Rule Added")
        })
        .addCase(get_province_rules.fulfilled,(state,action)=>{
            state.rules = action.payload.data
        })
        .addCase(update_province_rule.fulfilled,state=>{
            toast.success("Province rule is updated successfuuly")
        })
        .addMatcher(isFulfilled(create_province_rule,get_province_rules,update_province_rule),state=>{
            state.isLoading=false
            state.isSuccess=true
            state.isError=false
        })
        .addMatcher(isPending(create_province_rule,get_province_rules,update_province_rule),state=>{
            state.isLoading=true
            state.isSuccess=false
            state.isError=false
        })
        .addMatcher(isRejected(create_province_rule,get_province_rules,update_province_rule),(state,action)=>{
            state.isError=true
            state.isSuccess=false
            state.isLoading=false
            toast.error(action.payload)
        })
    }
})

export default create_rules_slice.reducer